import moment from 'moment'
import update from 'immutability-helper'
import React from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Grow from '@mui/material/Grow'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import {BlueButton} from './buttons'
import EditComment from './edit-comment'
import Comment from './comment'
import Dialog from '../../../responsive-fullscreen-dialog'
import create, {createPost} from '../../../../helpers/command'
import {uuid} from '../../../../helpers/utils'


const useStyles = makeStyles(writeCommentsStyles)

export default function WriteComments ({context}) {

  const {quizAssessmentToReview: assessment = {}, translate} = context
  const {comments = []} = assessment.properties || {}

  const [newComment, setNewComment] = React.useState({comment: '', opened: false})
  const [deleteCommentState, setDeleteCommentState] = React.useState({open: false, comment: {}})
  const classes = useStyles()

  function handleNewCommentChange(e) {
    setNewComment({...newComment, comment: e.target.value})
  }

  function handleNewCommentCancel() {
    setNewComment({comment: '', opened: false})
  }

  async function handleNewCommentSave() {
    if (newComment.comment && newComment.comment.length > 0) {
      const newComments = update(comments, {$splice: [[0, 0, {id: uuid(), comment: newComment.comment, added: moment().toISOString()}]]})
      const {quizAssessmentToReview: {id, properties}} = await context.updateState({quizAssessmentToReview: {properties: {comments: {$set: newComments}}}})
      createPost('quiz','saveReviewProperties')({id, properties})
    }
    handleNewCommentCancel()
  }

  const openDeleteComment = comment => setDeleteCommentState({open: true, comment}) 
  const cancelDeleteComment = () => setDeleteCommentState({open: false, comment: {}})

  async function deleteComment(comment) {
    const index = comments.findIndex(c => c.id == comment.id)
    if (index >= 0) {
      const newComments = update(comments, {$splice: [[index, 1]]})
      const {quizAssessmentToReview: {id, properties}} = await context.updateState({quizAssessmentToReview: {properties: {comments: {$set: newComments}}}})
      createPost('quiz','saveReviewProperties')({id, properties})
    }
    cancelDeleteComment()
  }

  return (
      <Box className={classes.root}>
        <Box className={classes.create}>
          <BlueButton startIcon={<AddIcon />} onClick={() => setNewComment({text: '', opened:true})} >
            {translate('add-annotation')}
          </BlueButton>
        </Box>
        {/* <Grow in={newComment.opened}> */}
          <Box className={classes.newComment}>
            {newComment.opened && <EditComment
              comment={newComment.comment}
              onChange={handleNewCommentChange}
              onCancel={handleNewCommentCancel}
              onSave={handleNewCommentSave}
              {...{context}}
            />}
          </Box>
        {/* </Grow> */}
        <Box className={classes.comments}>
          {comments.map((comment, index) => (<Comment key={comment.id} onDeleteComment={openDeleteComment} {...{comment, index, context}} />))}
        </Box>
      <DeleteCommentDialog
        onCancel={cancelDeleteComment}
        onConfirm={deleteComment}
        open={deleteCommentState.open}
        comment={deleteCommentState.comment}
        context={context}
      />
      </Box>
    )
}

function DeleteCommentDialog (props) {
  const {open, comment, context, onConfirm, onCancel} = props
  const {translate} = context
  return (
    <Dialog
      open={open}
      close={onCancel}
      confirm={<Button variant="contained" color="primary" onClick={() => onConfirm(comment)}>{translate('delete')}</Button>}
      cancel={<Button variant="contained" color="secondary" onClick={onCancel}>{translate('cancel')}</Button>}
      title={translate('confirm_delete_item')}
    >
      {comment.comment && translate('delete-comment-message', {comment: comment.comment})}
    </Dialog>
  )
}

function writeCommentsStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      padding: '0 20px',
      overflowY: 'auto',
      [theme.breakpoints.down('sm')]: {
        padding: '0 10px'
      }
    },
    create: {
      padding: '20px 0'
    },
    newComment: {
      '& textarea': {
        flexGrow: 1,
        resize: 'none'
      },
    },
    comments: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      '& > div': {
        marginTop: '20px',
      }
    },
    buttons: {
      padding: '20px 0',
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      }
    },
  };
}
